import TrashCan20 from '@carbon/icons-react/es/trash-can/20';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { components } from 'react-select';
import styled from 'styled-components';
import {
  Option,
  OptionProps,
  SingleValue,
} from 'components/atoms/select/types';
import { Tag } from 'components/atoms/tag';
import { SingleLineEllipsis } from 'components/styles';
import { getRandomColor } from 'utils/get-random-color';
import { CategoryName } from '../category-name';
import { TitleSelect } from './title-select';
import { TitleSelectTrigger } from './title-select-trigger';

const StyledTag = styled(Tag)`
  ${SingleLineEllipsis};
  max-width: 100%;
`;

const Trigger = ({ value: option }): JSX.Element => {
  if (option.value === 0) {
    return <TitleSelectTrigger label={option.label} />;
  }

  return (
    <TitleSelectTrigger
      label={
        <CategoryName
          name={option.label}
          deleted={option.extra?.deleted}
          trashIcon={<TrashCan20 />}
        />
      }
      description={<FormattedMessage id="timesheets.reports.tabs.category" />}
    />
  );
};

const CategoryOption = (props: OptionProps): JSX.Element => {
  const { data, isSelected, ...restProps } = props;

  return (
    <>
      <components.Option data={data} isSelected={isSelected} {...restProps}>
        {data.value === 0 ? (
          <span>{data.label}</span>
        ) : (
          <StyledTag color={getRandomColor(data.value)}>
            <CategoryName name={data.label} deleted={data.extra?.deleted} />
          </StyledTag>
        )}
      </components.Option>
    </>
  );
};

interface Props {
  options: Option[];
  onChange: (value: SingleValue<number>) => void;
  selected?: Option;
}
export const CategorySelect: FC<Props> = ({ options, onChange, selected }) => {
  return (
    <TitleSelect
      options={options}
      onChange={onChange}
      selected={selected}
      triggerComponent={Trigger}
      components={{ Option: CategoryOption }}
      virtualized={false}
    />
  );
};
